import { Box, Heading } from '@radix-ui/themes';
import { Responsive } from '@radix-ui/themes/dist/cjs/props/prop-def';
import { RX } from 'enums/radix';

export const FormHeading = (props: {
  label: string;
  gridColumn?: Responsive<string>;
}) => (
  <Box gridColumn={props.gridColumn}>
    <Heading size="2" color={RX.CLR.HIGHLIGHT}>
      {props.label}
    </Heading>
  </Box>
);
